import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import {
  PDFTEMPLATES_TYPES,
  TEMPLATEPDF_CONSTANTS,
  TEMPLATEPDF_MESSAGES,
  TEMPLATE_PDF_ACCESS
} from "./constants/TemplatePdfConstants";

import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import SaveTemplatePdf from "./components/SaveTemplatePdf/SaveTemplatePdf.vue";
import { SearchContext } from "../../shared/models/SearchContext";
import store from "@/store";
import { Route, NavigationGuardNext } from "vue-router";
import { TemplatePdfService } from "../TemplatePdf/services/templatePdfService";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Http } from "@status/codes";

import { mapGetters } from "vuex";
import { MenuDataStructure } from "../../shared/models/MenuDataStructure";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import { Utils } from "@/shared/utils/utils";
import SaveActionPlanTemplate from "./components/SaveActionPlanTemplate/SaveActionPlanTemplate.vue";
import { TemplatePdf as TemplatePdfModel } from "./Models/templatePdf";
import { MultimediaSelected } from "@/shared/components/MultimediaManager/models/MultimediaSelected.model";
import { TemplatePdfQuery } from "./Models/templatePdfQuery";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "TemplatePdf",
  components: {
    SaveTemplatePdf,
    ModalTemplate,
    ObservationModal,
    SaveActionPlanTemplate
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class TemplatePdf extends Vue {
  @Inject() templatePdfService!: TemplatePdfService;

  dataToMainView!: MenuDataStructure;

  PAGE_TITLE = TEMPLATEPDF_CONSTANTS.PAGE_TITLE;

  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  currentTooltip = TEMPLATEPDF_CONSTANTS.ADD_TEMPLATEPDF;

  primaryBtnClassRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  selectedTemplateId = "";
  auxTemplateId = "";

  pdfTemplateList: any = [];
  addTemplatePdf = false;

  OPERATIONS: string[] = [];

  filterItems = TEMPLATEPDF_CONSTANTS.TEMPLATEPDF_FILTERS.MAIN;

  // modals components
  dialogInfo = false;
  modalInfoTitle = "";
  modalInfoText = "";
  dialogObservation = false;
  actionMode = "";
  itemState = false;
  idDeleting = "";
  observationModalTitle = "";
  observationModalText = "";
  actionCancel = COMPONENT_NAME_MODAL.TEMPLATE_PDF;
  addActionPlanTemplate = false;
  templateToEdit: TemplatePdfModel = {
    name: "",
    businessDetails: [
      { logo: false },
      { nit: false },
      { phone: false },
      { companyName: false },
      { address: false }
    ],
    multimediaFooter: {} as MultimediaSelected,
    multimediaHeader: {} as MultimediaSelected,
    state: true
  };

  //   query
  querySearch?: TemplatePdfQuery = {};

  callCancelModal() {
    const modalUserTemplate: SearchContextModal = {
      componentName: this.actionCancel
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL,
      modalUserTemplate
    );
  }

  async showSaveTemplatePdf(id: string, action: string) {
    if (action == "editData") {
      const template = await this.getTemplateData(id);
      if (!template)
        return Snackbar.popError(TEMPLATEPDF_MESSAGES.ERROR_GET_TEMPLATE_PDF);
      this.templateToEdit = { ...template };
      this.selectedTemplateId = id;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        id
      );
      this.changeTitleText(TEMPLATEPDF_CONSTANTS.EDIT_TEMPLATEPDF);

      const actionTemplate =
        !!template.type && template.type == PDFTEMPLATES_TYPES.ACTION_PLAN;

      this.formAddTemplatePdf(true, actionTemplate);
    }

    if (action == "addData") {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.selectedTemplateId = "";
        this.changeTitleText(TEMPLATEPDF_CONSTANTS.ADD_TEMPLATEPDF);
        this.formAddTemplatePdf(true, false);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
        );
      } else {
        this.callCancelModal();
      }
    }
  }

  changeTitleText(title: string) {
    this.PAGE_TITLE = title;
  }

  formAddTemplatePdf(val: boolean, actionTemplate: boolean) {
    if (actionTemplate) {
      this.addActionPlanTemplate = actionTemplate;
      this.addTemplatePdf = false;
    } else {
      this.addTemplatePdf = val;
      this.addActionPlanTemplate = false;
    }
    if (val) {
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = FORM_CONSTANTS.BUTTON.CANCEL;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM);

      this.addActionPlanTemplate = false;
      this.querySearch = {};
      this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
      this.currentTooltip = TEMPLATEPDF_CONSTANTS.PAGE_TITLE;
      this.selectedTemplateId = "";
      this.PAGE_TITLE = TEMPLATEPDF_CONSTANTS.PAGE_TITLE;
    }
  }

  // obtiene los datos que se muestran en el panel lateral
  async getDataInitial() {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );

    const filterQuery: TemplatePdfQuery = {};

    if (this.querySearch?.name) {
      filterQuery.name = this.querySearch.name;
    }

    if (this.querySearch?.state) {
      filterQuery.state = this.querySearch.state;
    }

    try {
      const response = await this.templatePdfService.getDataInitial(
        filterQuery
      );
      if (response.code == Http.Found && response.data != undefined) {
        this.pdfTemplateList = response.data["pdfTemplateList"];
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          this.pdfTemplateList
        );
      } else {
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
        Snackbar.popInfo(response.message);
      }
    } catch (error) {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${TEMPLATE_PDF_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  contextPanel() {
    this.initializeFilters();
    const searchContext: SearchContext = {
      title: TEMPLATEPDF_CONSTANTS.PAGE_TITLE,
      filterArray: [this.filterItems],
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.TEMPLATE_PDF,
      descriptions: ["state"],
      optionsToFilter: [],
      textButtonCreate: TEMPLATEPDF_CONSTANTS.ADD_TEMPLATEPDF
    };

    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.editTemplate(itemId);
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateTemplate(itemId, STATE.ACTIVE);
        this.formAddTemplatePdf(false, false);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateTemplate(itemId, STATE.INACTIVE);
        this.formAddTemplatePdf(false, false);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        await this.deleteTemplatePdf(itemId);
        this.formAddTemplatePdf(false, false);
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        switch (this.actionCancel) {
          case COMPONENT_NAME_MODAL.TEMPLATE_PDF:
            this.formAddTemplatePdf(false, false);
            break;
        }
        break;
    }
  }

  async updateStateTemplate(itemId: string, state: string) {
    const messageResponse =
      state == STATE.INACTIVE
        ? TEMPLATEPDF_MESSAGES.INACTIVATE_SUCCESSFULLY
        : TEMPLATEPDF_MESSAGES.ACTIVE_SUCCESSFULLY;

    const response = await this.templatePdfService.changeStatus(itemId, state);
    if (response.code == Http.Ok) {
      Snackbar.popSuccess(messageResponse);
      await this.getDataInitial();
    } else {
      Snackbar.popInfo(response.message);
    }
  }

  async deleteTemplatePdf(itemId: string) {
    const response = await this.templatePdfService.deleteTemplate(itemId);
    if (response.code == Http.Ok) {
      Snackbar.popSuccess(TEMPLATEPDF_MESSAGES.DELETE_SUCCESSFULLY);
      await this.getDataInitial();
    } else {
      Snackbar.popInfo(response.message);
    }
  }

  // este metodo controlar la informacion que se va a mostrar para editar
  editTemplate(templateId: string) {
    this.selectedTemplateId = "";
    if (templateId) {
      this.showSaveTemplatePdf(templateId, "editData");
    } else {
      this.modalInfoText = FORM_MESSAGES.CHANGE_MODAL.MESSAGE;
      this.modalInfoTitle = FORM_MESSAGES.CHANGE_MODAL.TITLE;
      this.auxTemplateId = templateId;
      this.dialogInfo = true;
    }
  }

  // este metodo inicia los filtros del panel derecho
  initializeFilters() {
    this.filterItems.secondaryFilters = [];
    this.filterItems.secondaryFilters.push(
      TEMPLATEPDF_CONSTANTS.TEMPLATEPDF_FILTERS.SECONDARY.NAME
    );
    this.filterItems.secondaryFilters.push(
      TEMPLATEPDF_CONSTANTS.TEMPLATEPDF_FILTERS.SECONDARY.STATUS
    );
  }

  // este metodo sirve para quitar el formulario de edición/nuevo registro y cargar las cards nuevamente
  async restoreTemplateForm() {
    await this.formAddTemplatePdf(false, false);
    await this.getDataInitial();
  }

  // Estos metodos sirven para controlar la visibilidad del modal general
  handleInfoModalAccept() {
    if (this.modalInfoTitle === FORM_MESSAGES.CHANGE_MODAL.TITLE) {
      this.showSaveTemplatePdf(
        this.auxTemplateId,
        TEMPLATEPDF_CONSTANTS.REFERENCES_TEXTS.EDIT_TEMPLATE
      );
    } else if (this.modalInfoTitle === FORM_MESSAGES.CANCEL_MODAL.TITLE) {
      this.restoreTemplateForm();
    }
    this.callCancelModal();
  }

  handleInfoModalCancel() {
    this.callCancelModal();
  }

  // este metodo es propio de VUE se ejecuta cuando el componente carga
  async mounted() {
    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.TEMPLATES_PDF
    );
    await this.getDataInitial();
    this.contextPanel();
    this.initializeFilters();
  }

  // este metodo sirve para filtrar desde el panel latera
  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getDataInitial();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT:
          this.sendDataToLateralMenu(
            PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT
          );
          break;
      }
    }
  }
  changeTemplatePdfType() {
    this.addTemplatePdf = !this.addTemplatePdf;
    this.addActionPlanTemplate = !this.addActionPlanTemplate;
  }
  async getTemplateData(id: string) {
    const responseData = await this.templatePdfService.getTemplateById(id);
    return responseData.data;
  }

  onButtonAdd() {
    this.showSaveTemplatePdf("", "addData");
  }
}
